(function () {
  var loader = document.getElementById('page-transition-loader');
  if (!loader) return;

  var SHOW_MS = 900; // how long the logo stays up before we actually navigate
  var HIDE_DELAY_MS = 350; // brief pause after the new page loads before fading out
  var MAX_SHOW_MS = 4000; // hard cap: force-hide the loader after this long no matter
                           // what, so a slow/hanging resource on the destination page
                           // (e.g. a heavy image or video on a product page) can never
                           // leave the full-screen loader stuck up indefinitely.

  var hideTimer = null;
  var navigateTimer = null;
  var maxShowTimer = null;
  var hasHiddenOnce = false; // guards against the load/pageshow/timeout handlers firing more than once
  var isNavigating = false; // guards against a second click re-triggering the sequence

  function clearPendingTimers() {
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    if (maxShowTimer) {
      clearTimeout(maxShowTimer);
      maxShowTimer = null;
    }
  }

  function hideLoader() {
    clearPendingTimers();
    loader.classList.add('is-hidden');
  }

  function showLoader() {
    clearPendingTimers();
    loader.classList.remove('is-hidden');
  }

  function scheduleHide() {
    if (hasHiddenOnce) return;
    hasHiddenOnce = true;
    clearPendingTimers();
    hideTimer = setTimeout(hideLoader, HIDE_DELAY_MS);
  }

  // Fade the loader out once the page has finished loading. Guarded so this
  // can only ever run once per page life, even if 'load' fires more than once
  // or races with the bfcache 'pageshow' handler below.
  //
  // If the document is already fully loaded by the time this script runs
  // (e.g. this script tag executed late, or the page was served from a
  // cache), 'load' has already fired and will never fire again — hide
  // immediately instead of waiting on an event that isn't coming.
  if (document.readyState === 'complete') {
    scheduleHide();
  } else {
    window.addEventListener('load', scheduleHide);
  }

  // Belt-and-braces fallback: no matter what the destination page is doing,
  // force the loader to hide after MAX_SHOW_MS. scheduleHide() is idempotent
  // (guarded by hasHiddenOnce), so this can never double-fire or conflict
  // with the normal load-based hide above.
  maxShowTimer = setTimeout(scheduleHide, MAX_SHOW_MS);

  // Handle pages restored from the back/forward cache, where 'load' does not
  // fire again — hide immediately rather than waiting on a timer that will
  // never come.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      hasHiddenOnce = true;
      hideLoader();
    } else {
      scheduleHide();
    }
  });

  document.addEventListener(
    'click',
    function (event) {
      if (isNavigating) return;

      var link = event.target.closest('a[href]');
      if (!link) return;

      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.target && link.target !== '' && link.target !== '_self') return;
      if (link.hasAttribute('download')) return;

      // Escape hatch for links that should navigate immediately with no
      // artificial delay (e.g. "View Bag" straight after a Quick Add — the
      // extra 900ms here just reads as lag right after an add-to-cart).
      if (link.hasAttribute('data-skip-transition')) return;

      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;

      var url;
      try {
        url = new URL(href, window.location.href);
      } catch (e) {
        return;
      }

      // Only intercept same-origin http(s) navigations; let mailto:, tel:, and
      // external links behave normally.
      if (url.origin !== window.location.origin) return;
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return;

      // Don't show the loader for a same-page anchor jump.
      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) {
        return;
      }

      event.preventDefault();

      // A second click on the same or another link while we're already
      // mid-transition used to be able to re-trigger showLoader() and stack a
      // second navigation timer on top of the first — that's the most likely
      // source of the "flicker" (loader hides, then reappears briefly, then
      // goes) some clicks were showing. One transition in flight at a time.
      isNavigating = true;
      clearPendingTimers();
      if (navigateTimer) {
        clearTimeout(navigateTimer);
      }

      showLoader();

      navigateTimer = setTimeout(function () {
        window.location.href = url.href;
      }, SHOW_MS);
    },
    true
  );
})();